export const formatAmountDisplay = (
	amount: number | string | null | undefined,
) => {
	const value = Number(amount ?? 0);

	if (!Number.isFinite(value)) return "0.00";

	return value.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};
